import { Expose, Transform } from 'class-transformer';

export class AppConsumptionModel {
  @Expose()
  @Transform(({ value }) => {
    return isNaN(value) ? 0 : value;
  })
  total: number = 0;

  @Expose()
  @Transform(({ value }) => {
    return isNaN(value) ? 0 : value;
  })
  consumption: number = 0;
}
